import React from "react";
import { Link } from "react-router-dom";
import { Printer, Download, ArrowLeft } from "lucide-react";
import QRCard from "@/components/QRCard";
import { WHATSAPP_DISPLAY } from "@/lib/pricing";

export default function Panfletos() {
  const print = () => window.print();
  return (
    <div className="min-h-screen bg-brand-creamDeep py-10 px-5 md:px-8" data-testid="panfletos-hub">
      <div className="no-print max-w-4xl mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
        <div>
          <Link to="/" className="inline-flex items-center gap-1 text-brand-green font-bold text-sm" data-testid="back-home">
            <ArrowLeft size={16} /> Voltar ao site
          </Link>
          <h1 className="font-display font-bold text-4xl md:text-5xl text-brand-green mt-2">Panfletos Cãomiar</h1>
          <p className="text-brand-brownDark mt-2 max-w-xl">
            Materiais rebrandeados do antigo Gisele Dog Walker. Ideal para impressão A4. Clique em <strong>Imprimir/Salvar PDF</strong> para gerar a versão para impressão.
          </p>
        </div>
      </div>

      <div className="no-print max-w-4xl mx-auto grid md:grid-cols-2 gap-6 mb-8">
        <PamphletTile
          href="/panfletos/promocional"
          title="Panfleto Promocional"
          subtitle="Convite para novos tutores"
          preview="promo"
          testid="tile-promocional"
        />
        <PamphletTile
          href="/panfletos/precos"
          title="Tabela de Valores"
          subtitle="Preços 30min e 1 hora"
          preview="prices"
          testid="tile-precos"
        />
      </div>

      <div className="no-print max-w-4xl mx-auto mb-8">
        <QRCard />
      </div>

      <div className="no-print max-w-4xl mx-auto bg-white border border-brand-cream rounded-3xl p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <div className="font-display text-2xl text-brand-green">Precisa do PDF pronto?</div>
          <p className="text-brand-brownDark text-sm">Abra qualquer panfleto e use o botão abaixo para salvar em PDF (Ctrl/Cmd + P → salvar como PDF).</p>
        </div>
        <button onClick={print} data-testid="print-hub" className="inline-flex items-center gap-2 rounded-full bg-brand-green text-brand-cream px-6 py-3 font-bold hover:bg-brand-greenDark transition-colors">
          <Printer size={18} /> Imprimir esta página
        </button>
      </div>
    </div>
  );
}

function PamphletTile({ href, title, subtitle, preview, testid }) {
  return (
    <Link to={href} data-testid={testid} className="group bg-white rounded-3xl overflow-hidden border border-brand-cream shadow-[0_10px_30px_rgba(0,0,0,0.06)] hover:shadow-[0_20px_60px_rgba(44,110,73,0.18)] hover:-translate-y-1 transition-[transform,box-shadow]">
      <div className="aspect-[210/297] bg-brand-cream relative">
        {preview === "promo" ? <PreviewPromo /> : <PreviewPrices />}
      </div>
      <div className="p-5 flex items-center justify-between">
        <div>
          <div className="font-display text-2xl text-brand-green">{title}</div>
          <div className="text-sm text-brand-brownDark">{subtitle}</div>
        </div>
        <div className="text-brand-green group-hover:translate-x-1 transition-transform">
          <Download size={22} />
        </div>
      </div>
    </Link>
  );
}

// ---------------- SVG previews ----------------
function PreviewPromo() {
  return (
    <svg viewBox="0 0 210 297" className="w-full h-full">
      <rect width="210" height="297" fill="#F8F0DC" />
      <text x="14" y="46" fontFamily="Fraunces, serif" fontWeight="700" fontSize="20" fill="#2C6E49">SEU CÃOZINHO</text>
      <text x="14" y="66" fontFamily="Fraunces, serif" fontWeight="700" fontSize="20" fill="#2C6E49">PASSA MUITO</text>
      <text x="14" y="86" fontFamily="Fraunces, serif" fontWeight="700" fontSize="20" fill="#2C6E49">TEMPO SOZINHO?</text>
      <rect x="120" y="110" width="80" height="70" rx="10" fill="#2C6E49" />
      <text x="132" y="140" fontFamily="Nunito, sans-serif" fontSize="9" fill="#F8F0DC" fontWeight="700">POR QUE CONTRATAR</text>
      <text x="132" y="152" fontFamily="Nunito, sans-serif" fontSize="9" fill="#F8F0DC" fontWeight="700">A CÃOMIAR?</text>
      <circle cx="60" cy="200" r="26" fill="#4A8F5F" />
      <circle cx="90" cy="205" r="22" fill="#8B5A2B" />
      <text x="14" y="270" fontFamily="Nunito, sans-serif" fontSize="10" fill="#2C6E49" fontWeight="700">Vamos passear? {WHATSAPP_DISPLAY}</text>
    </svg>
  );
}
function PreviewPrices() {
  return (
    <svg viewBox="0 0 210 297" className="w-full h-full">
      <rect width="210" height="297" fill="#F8F0DC" />
      <text x="14" y="40" fontFamily="Fraunces, serif" fontWeight="700" fontSize="18" fill="#2C6E49">TABELA DE VALORES</text>
      <rect x="14" y="55" width="180" height="90" fill="none" stroke="#2C6E49" strokeWidth="1.4" rx="6" />
      <rect x="14" y="55" width="180" height="14" fill="#2C6E49" />
      <text x="42" y="65" fontFamily="Nunito, sans-serif" fontSize="8" fontWeight="700" fill="#F8F0DC">PASSEIOS DE 30 MINUTOS</text>
      <rect x="14" y="160" width="180" height="90" fill="none" stroke="#2C6E49" strokeWidth="1.4" rx="6" />
      <rect x="14" y="160" width="180" height="14" fill="#2C6E49" />
      <text x="42" y="170" fontFamily="Nunito, sans-serif" fontSize="8" fontWeight="700" fill="#F8F0DC">PASSEIOS DE 1 HORA</text>
      <circle cx="30" cy="275" r="8" fill="#8B5A2B" opacity="0.5" />
      <circle cx="180" cy="275" r="8" fill="#8B5A2B" opacity="0.5" />
    </svg>
  );
}
